export default "__VITE_ASSET__CCcHclpJ__"